import { useEffect } from "react";

const DisableInspect = () => {
  useEffect(() => {
    const disableRightClick = (e) => {
      e.preventDefault();
    };

    const disableInspect = (e) => {
      if (
        e.key === "F12" ||
        (e.ctrlKey && e.shiftKey && e.key === "I") ||
        (e.ctrlKey && e.key === "U")
      ) {
        e.preventDefault();
      }
    };

    document.addEventListener("contextmenu", disableRightClick);
    document.addEventListener("keydown", disableInspect);

    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
      document.removeEventListener("keydown", disableInspect);
    };
  }, []);

  return null;
};

export default DisableInspect;
